import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f4fa206"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "contato",
  class: "main-contatos"
}
const _hoisted_2 = { class: "coluna-cartoes" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rotulo-secao" }, " Contato ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "titulo-secao" }, " Fale com a LimaTec. ", -1))
const _hoisted_5 = { class: "lista-cartoes" }
const _hoisted_6 = { class: "cartao-contato" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icone-contato" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "22",
    height: "22",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" })
  ])
], -1))
const _hoisted_8 = { class: "texto-contato" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legenda-contato" }, " Telefone e WhatsApp ", -1))
const _hoisted_10 = { class: "valor-destaque" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "cartao-contato" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icone-contato" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "22",
    height: "22",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" }),
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "10",
      r: "2.5"
    })
  ])
], -1))
const _hoisted_14 = { class: "texto-contato" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legenda-contato" }, " Endereço ", -1))
const _hoisted_16 = { class: "valor-contato" }
const _hoisted_17 = { class: "detalhe-contato" }
const _hoisted_18 = { class: "cartao-contato" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icone-contato" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "22",
    height: "22",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "9"
    }),
    /*#__PURE__*/_createElementVNode("path", { d: "M12 7v5l3 2" })
  ])
], -1))
const _hoisted_20 = { class: "texto-contato" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legenda-contato" }, " Horário de funcionamento ", -1))
const _hoisted_22 = { class: "valor-contato" }
const _hoisted_23 = { class: "detalhe-contato" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "coluna-mapa" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.724627378872!2d-56.488052!3d-21.123541999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x947c5f553c2264f1%3A0xae03f8707e275560!2sLimaTec%20-%20El%C3%A9trica%20-%20Automa%C3%A7%C3%A3o%20-%20Energia%20Solar!5e0!3m2!1spt-BR!2sbr!4v1703254480040!5m2!1spt-BR!2sbr",
    title: "Mapa com a localização da LimaTec em Bonito/MS",
    loading: "lazy",
    referrerpolicy: "no-referrer-when-downgrade"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.TelefoneSecundario), 1)
          ]),
          _createElementVNode("a", {
            href: _ctx.telefoneHref,
            class: "botao-pilula botao-ligar"
          }, " Ligar agora ", 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.Logradouro), 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.Cidade) + " · " + _toDisplayString(_ctx.Cep) + " · " + _toDisplayString(_ctx.Pais), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.HorasAtendimento), 1),
            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.DiasAtendimento), 1)
          ])
        ])
      ])
    ]),
    _hoisted_24
  ]))
}